/**
 * Check if a subscription status is active
 * @param status - Subscription status string
 * @returns true if subscription is active or in trial period
 */
export const isSubscriptionActive = (
  status: string | undefined | null
): boolean => {
  return status === "active" || status === "trialing";
};

/**
 * Check if user can access premium features
 * Alias for isSubscriptionActive for better semantic meaning
 */
export const canAccessPremiumFeatures = isSubscriptionActive;
